module.exports = __webpack_public_path__ + "img/dh_ico.18a6de8f.png";